import { useState } from 'react';
import { LogOut, User, ChevronDown, History, UserPlus, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { getAvatarById } from './AvatarPicker';

export default function UserMenu() {
  const { user, signOut } = useAuthStore();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  if (!user) return null;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-white bg-opacity-5 rounded-lg hover:bg-opacity-10 transition"
      >
        {user.photoURL && getAvatarById(user.photoURL) ? (
          <div className="w-8 h-8 bg-gradient-to-br from-pink-600 to-violet-600 rounded-full flex items-center justify-center text-lg">
            {getAvatarById(user.photoURL)!.emoji}
          </div>
        ) : (
          <div className="w-8 h-8 bg-pink-600 rounded-full flex items-center justify-center">
            <span className="text-white font-semibold">
              {user.displayName?.charAt(0) || user.email?.charAt(0) || '?'}
            </span>
          </div>
        )}
        <span className="hidden md:inline">{user.displayName || 'User'}</span>
        <ChevronDown size={16} className={`transform transition ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white bg-opacity-10 backdrop-blur-lg rounded-xl shadow-xl py-1 z-50">
          <button
            onClick={() => {
              setIsOpen(false);
              navigate('/profile');
            }}
            className="w-full px-4 py-2 text-left hover:bg-white hover:bg-opacity-5 transition flex items-center gap-2"
          >
            <User size={16} />
            Profile
          </button>
          <button
            onClick={() => {
              setIsOpen(false);
              navigate('/history');
            }}
            className="w-full px-4 py-2 text-left hover:bg-white hover:bg-opacity-5 transition flex items-center gap-2"
          >
            <History size={16} />
            Game History
          </button>
          <button
            onClick={() => {
              setIsOpen(false);
              navigate('/friends');
            }}
            className="w-full px-4 py-2 text-left hover:bg-white hover:bg-opacity-5 transition flex items-center gap-2"
          >
            <UserPlus size={16} />
            Friend Requests
          </button>
          {user.isAdmin && (
            <>
              <hr className="my-1 border-white border-opacity-10" />
              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate('/admin');
                }}
                className="w-full px-4 py-2 text-left hover:bg-white hover:bg-opacity-5 transition flex items-center gap-2 text-pink-300"
              >
                <Shield size={16} />
                Admin Panel
              </button>
            </>
          )}
          <hr className="my-1 border-white border-opacity-10" />
          <button
            onClick={() => {
              setIsOpen(false);
              signOut();
            }}
            className="w-full px-4 py-2 text-left hover:bg-white hover:bg-opacity-5 transition flex items-center gap-2 text-red-400"
          >
            <LogOut size={16} />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}